import { EpiContentBlock, EpiLink } from '@api/types';
import { Grid } from '@mui/material';

import { TextCodes } from '@api/types/translation/TextCodes';
import { Button, Html, Image, SmartLink, Title } from '@components';
import { Box, styled } from '@mui/material';
import { t } from '@translations';

type ContentListItemBlockProps = {
  block: EpiContentBlock & {
    link: EpiLink;
  };
  contentItemLinkText?: string;
};

// STYLED COMPONENTS
const ContentListItemWrapper = styled(Box)`
  height: 100%;
  border-radius: 4px;
  img {
    border-radius: 4px;
    height: 330px !important;
    width: 100%;
  }
`;

const ContentBox = styled(Box)`
  -webkit-box-pack: justify;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: auto;

  span,
  p {
    font-size: 16px !important;
    margin-bottom: 0;
  }
  .content-list-item-title {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .button-link {
    width: fit-content;
  }
`;

const DescriptionWrapper = styled(Box)`
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
`;

export const ContentListItemBlock: React.FC<ContentListItemBlockProps> = ({
  block,
  contentItemLinkText,
}: ContentListItemBlockProps) => {
  return (
    <Grid item xs={12} md={6}>
      <ContentListItemWrapper>
        <Image
          image={block?.image}
          {...block?.imageConfig}
          resizerParams={{ width: 500, format: 'webp' }}
        />
        <ContentBox>
          <Title variant='h3' className='content-list-item-title' noDot color='default'>
            {block?.title}
          </Title>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}
          >
            {block?.text && (
              <DescriptionWrapper className='content-list-item-description'>
                <Html html={block?.text} />
              </DescriptionWrapper>
            )}

            {block?.link?.href && (
              <SmartLink href={block?.link?.href} className='button-link'>
                <Button variant='secondary' sx={{ alignSelf: 'flex-start' }}>
                  {contentItemLinkText || t(TextCodes.Base.ReadMore)}
                </Button>
              </SmartLink>
            )}
          </Box>
        </ContentBox>
      </ContentListItemWrapper>
    </Grid>
  );
};
